var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckmarkOrange(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 19"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#checkmark_orange_svg__clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#d55a39",
    d: "M20.29 0L9 11.57 3.71 6.56 0 10.27 9 19 24 3.71 20.29 0z"
  }))));
}
export default SvgCheckmarkOrange;